import { GlocalStyle } from './styled/GlocalStyle'; //styled-components
import ToDoList from './components/ToDoList';

function App() {
  return (
    <>
      <GlocalStyle />
      <ToDoList />
    </>
  );
}

export default App;
